import { Component, OnInit } from '@angular/core';
import { TruckType } from '../../../../modules/pick-plan/models/truck-type';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../../../../../@core/utils/session.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'truck-type-details',
  templateUrl: './truck-type-details.component.html',
  styleUrls: ['./truck-type-details.component.scss']
})
export class TruckTypeDetailsComponent implements OnInit {
  //#region Properties
  public editActive = false;
  public truckTypeLoading = true;
  public editTruckType: TruckType = {};
  public submitting: any;
  //#endregion

  //#region Constructor with Dependencies
  constructor(
    public dialogRef: MatDialogRef<any>,
    private session: SessionService
  ) {}
  //#endregion

  ngOnInit() {
    this.editTruckType = this.session.selectedTruckType || {};
    if (this.editTruckType.id === undefined) {
      this.editTruckType.isActive = true;
      this.truckTypeLoading = false;
    }
  }

  cancelClicked(form: NgForm, cancelled: boolean = false) {
    this.editActive = false;
    this.editTruckType = {};
    form.resetForm();
    this.dialogRef.close(cancelled);
  }

  onSubmit() {
    // Close right away and let the list component perform the actual
    // create/update in the background.
    this.submitting = true;
    setTimeout(() => {
      if (this.editTruckType.id) {
        this.dialogRef.close({
          backgroundSave: true,
          isNew: false,
          truckType: { ...this.editTruckType }
        });
      } else {
        this.dialogRef.close({
          backgroundSave: true,
          isNew: true,
          truckType: { ...this.editTruckType }
        });
      }
    }, 200);
  }

}
